import React, { useEffect, useState } from 'react';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { Box, Button, Card, Chip, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { AccountCircle, ArrowBack, Edit } from '@mui/icons-material';
import dayjs from 'dayjs';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { PermissionGuard } from '../../../components/PermissionGuard';
import Swal from 'sweetalert2';
import Loading from '../../../components/Loader/Loading';
import { CouponServices } from './CouponServices';
import { CustomerService } from '../../Customer/Service';
import isExpired from '../../../utils/checkCouponExpiry';
import { DataGrid } from '@mui/x-data-grid';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';

const ViewCouponDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [couponData, setCouponData] = useState({
        selectedCustomers: []
    });
    const [isLoading, setIsLoading] = useState(false);
    const fetchCouponData = async () => {
        setIsLoading(true);
        try {
            const response = await CouponServices.getCouponById(id);
            if (response.success == '1') {
                const data = response.data;
                setCouponData(data);
            }
        } catch (error) {
            console.log("fetching Banner Details error", error);
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: error.message,
                timer: 2000
            });
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchCustomerlist();
        if (id > 0) {
            fetchCouponData();
        }
    }, [])
    const [customerList, setCustomerList] = useState([]);

    // fetch customer list
    const fetchCustomerlist = async () => {
        try {
            const customerListResponse = await CustomerService.unsortedCustomerList();
            if (customerListResponse.success === 1) {
                setCustomerList(customerListResponse.data)
            }
        } catch (error) {
            console.log('error', error)
        }
    }
    // useEffect(() => {
    //     if (customerList.length > 0 && couponData.selectedCustomers.length > 0) {

    //     }
    // }, [customerList])
    const columns = [
        { 
            field: 'bookingNumber', 
            headerName: 'Booking ID', 
            headerAlign:'center',
            flex: 1,
            renderCell: (params) => (
                <PermissionGuard
                    feature="booking" 
                    permission="canView" 
                    fallback={
                        <Typography sx={{ fontSize: '0.65rem',color: '#1976d2',p:1 }}>
                        #{params.row.bookingNumber}
                        </Typography>
                    }
                    >
                    <Typography 
                        sx={{ 
                        cursor: 'pointer', 
                        fontSize: '0.65rem', 
                        color: '#1976d2',
                        p:1
                        }}
                        onClick={() => window.open(`/admin/booking-details/${params.row.id}`, '_blank')}
                    >
                        #{params.row.bookingNumber}
                    </Typography>
                </PermissionGuard>
            ),
        },
        {
            field:'customer',headerName:`Customer Detail's`,flex:1.5, headerAlign:'center',
            renderCell: (params) => (
                <PermissionGuard
                    feature="customer"
                    permission="canView"
                    fallback={
                        <Typography sx={{ fontSize: '0.65rem', color: '#1976d2' }}>
                            {params.row.customer?.profile?.firstName || ''} {params.row.customer?.profile?.middleName || ''} {params.row.customer?.profile?.lastName || ''}
                        </Typography>
                    }
                >
                    <Typography
                        sx={{
                            // cursor: 'pointer',
                            fontSize: '0.65rem',
                            // color: '#1976d2'
                        }}
                        onClick={() => window.open(`/admin/customer-details/${params.row.customerId}`, '_blank')}
                    >
                       <Box component={'span'} sx={{
                            cursor: 'pointer',
                            fontSize: '0.65rem',
                            color: '#1976d2'
                        }}> {params.row.customer?.id}</Box>
                        _{params.row.customer?.profile?.firstName || ''} {params.row.customer?.profile?.middleName || ''} {params.row.customer?.profile?.lastName || ''} ({params.row.customer?.mobileNumber})
                    </Typography>
                </PermissionGuard>
            ),
        },
        {
            field:'couponAmount',
            headerName:'Coupon Amount',
            headerAlign:'center',
            renderCell: (params) => (
                <Typography sx={{ fontSize: '0.65rem', }}>
                    ₹{parseFloat(params.row.couponAmount).toFixed(2)}
                </Typography>
            )
        }
    ]
    return (
        <>
            {isLoading && <Loading />}
            <PageHeaderLayout headerTitle={`Coupon Detail's`}>
                <Button variant='contained' onClick={() => navigate('/marketing/coupons')} size='small' sx={{}} >
                    Coupon List
                </Button>
            </PageHeaderLayout>
            <Grid container spacing={2}>
                <Grid item xs={12} md={5}>
                    <Card sx={{ p: 2 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Coupon Title</Typography>
                                <TextField
                                    disabled
                                    value={couponData.title}
                                    fullWidth
                                    size='small'
                                    InputProps={{
                                        style: { fontSize: '0.65rem' }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Coupon Type</Typography>
                                <TextField
                                    disabled
                                    value={couponData?.couponType}
                                    fullWidth
                                    size='small'
                                    InputProps={{
                                        style: { fontSize: '0.65rem', textTransform: 'capitalize' }
                                    }}
                                />

                            </Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Coupon Code</Typography>
                                <TextField
                                    disabled
                                    value={couponData?.couponCode}
                                    fullWidth
                                    size='small'
                                    InputProps={{
                                        style: { fontSize: '0.65rem' }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Coupon Value(%)</Typography>
                                <TextField
                                    disabled
                                    value={couponData?.couponValue}
                                    fullWidth
                                    size='small'
                                    InputProps={{
                                        style: { fontSize: '0.65rem' }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                                    Min. Booking Amt.
                                </Typography>
                                <TextField
                                    size='small'
                                    disabled
                                    value={couponData?.minimumBookingAmt}
                                    fullWidth
                                    InputProps={{ style: { fontSize: '0.65rem' },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography sx={{fontSize: '0.65rem'}}>₹</Typography>
                                        </InputAdornment>
                                    )
                                 }}
                                    
                                />
                            </Grid>

                            <Grid item xs={1}></Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>
                                    Max. Disount Amt.
                                </Typography>
                                <TextField
                                    size='small'
                                    disabled
                                    value={couponData?.maximumDiscount}
                                    fullWidth
                                    InputProps={{ 
                                        style: { fontSize: '0.65rem' },
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography sx={{fontSize: '0.65rem'}}>₹</Typography>
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Start Date</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        disabled
                                        sx={{
                                            width: '100%',
                                            '& .MuiInputBase-root': {
                                                fontSize: '0.65rem'
                                            }
                                        }}
                                        value={couponData?.startDate ? dayjs(couponData?.startDate) : null}
                                        format="DD-MM-YYYY"
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>End Date</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DesktopDatePicker
                                        disabled
                                        sx={{
                                            width: '100%',
                                            '& .MuiInputBase-root': {
                                                fontSize: '0.65rem'
                                            }
                                        }}
                                        value={couponData?.endDate ? dayjs(couponData?.endDate) : null}
                                        format="DD-MM-YYYY"
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                size: 'small',
                                                inputProps: {
                                                    style: { fontSize: '.75rem' }
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>

                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Selected Customers</Typography>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, border: '1px solid lightGray', p: '1%', borderRadius: '.25rem', minHeight: '2.5rem' }}>
                                    {customerList.length > 0 && couponData?.selectedCustomers.length > 0 && couponData?.selectedCustomers.map(selected => {
                                        console.log("id", id)
                                        const customer = customerList.find(opt => opt.id == selected.id);
                                        console.log("customer", customer)
                                        // if (customer) {
                                        return (
                                            <Chip
                                                key={id}
                                                label={`${customer.id}_ ${customer?.profile?.firstName} ${customer?.profile.middleName} ${customer?.profile?.lastName}`}
                                                color="primary"
                                                variant="outlined"
                                                size="small"
                                                sx={{ fontSize: '.65rem' }}
                                            />
                                        );
                                        // }
                                        // return null;
                                    })}
                                </Box>
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>limit Per User</Typography>
                                <TextField
                                    fullWidth
                                    disabled
                                    type='number'
                                    size='small'
                                    value={couponData?.limitPerUser}
                                    InputProps={{
                                        style: { fontSize: '0.65rem' }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5.5}>
                                <Typography sx={{ fontSize: '0.85rem', fontWeight: 600 }}>Description</Typography>
                                <TextField
                                    disabled
                                    value={couponData?.description}
                                    fullWidth
                                    size='small'
                                    InputProps={{
                                        style: { fontSize: '0.65rem' }
                                    }}
                                />
                            </Grid>
                            { !isExpired(couponData?.endDate) &&
                                <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <PermissionGuard feature='coupon' permission='canEdit'>
                                    <Button
                                        variant='contained'
                                        size='small'
                                        color='warning'
                                        startIcon={<Edit />}
                                        onClick={() => navigate(`/marketing/coupon/${id}`)}
                                        sx={{ textTransform: 'capitalize', fontSize: '.75rem' }}
                                    >
                                        Edit
                                    </Button>
                                </PermissionGuard>
                                </Grid>
                            }
                        </Grid>
                    </Card>
                </Grid>
                <Grid item xs={12} md={7}>
                    <Card>
                        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
                            <Typography sx={{fontWeight:'600',fontSize:'0.85rem'}}>Associated Bookings</Typography>
                        </Box>
                        <Box sx={{ overflow: "auto" }}>
                            <Box 
                                sx={{ 
                                    width: "100%", display: "table",  tableLayout: "fixed", 
                                    backgroundColor: "#fff", borderRadius: '.5rem',
                                    '& .odd': {
                                    bgcolor: 'white',
                                    },
                                    '& .even': {
                                    bgcolor: '#ECECEC',
                                    },
                                }}
                            >
                                <DataGrid
                                    rows={couponData?.associatedBookings || []}
                                    columns={columns.map((col) => ({
                                    ...col,
                                    flex: col.flex || 1, // Ensure columns resize dynamically
                                    minWidth: col.minWidth || 180, // Set a minimum width to avoid overlap
                                    }))}
                                    // getRowId={(row) => row.id}
                                    //checkboxSelection={true}
                                    // rowCount={allRowCount}  // Use the length of the filtered list
                                    pageSizeOptions={[5, 10, 20, 50, 100]}
                                    // i want on load 5 items to be shown
                                    initialState={{
                                        pagination: {
                                            paginationModel: { pageSize: 5, page: 0 },
                                        },
                                    }}
                                //   filterModel={filterModel}
                                    loading={isLoading}
                    
                                    disableColumnMenu
                                    disableRowSelectionOnClick
                                    // disableColumnFilter
                                    // disableColumnSelector
                                    // disableDensitySelector
                                    slots={{
                                    // toolbar: GridToolbar,
                                    noRowsOverlay: NoRowsLayout,
                                    loadingOverlay: Loading,
                                    }}
                                    // slotProps={{
                                    //   toolbar: {
                                    //     showQuickFilter: true,  
                                    //   },
                                    // }}
                                    // rowHeight={50}
                                    autoHeight
                                    getRowHeight={() => 'auto'}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                        border: 1,
                                        borderRight: 0,
                                        borderTop: 0,
                                        borderColor: 'lightgrey',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                                        // borderTop: '2px solid rgba(224, 224, 224, 1)',
                                        borderTopRightRadius:0,
                                        borderTopLeftRadius:0,
                                        fontWeight: 600,
                                        fontSize: '0.75rem',
                                        p:0,
                                        height: 'fit-content',
                                        minHeight:'0 !important',
                                        height:'2rem'
                                        },
                                        '& .MuiDataGrid-columnHeader': {
                                        borderLeft: '1px solid rgba(224, 224, 224, 1)',
                                        borderTopRightRadius:0,
                                        borderTopLeftRadius:0,
                                        '&:last-child': {
                                            borderRight: 'none',
                                        },
                                        },
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                        fontWeight: 600,
                                        color: '#3e3e3e'
                                        },
                                        '& .MuiDataGrid-row': {
                                        '&:last-child .MuiDataGrid-cell': {
                                            borderBottom: '1px solid rgba(224, 224, 224, 1)',
                                        },
                                        '& .MuiDataGrid-cell:last-child': {
                                            borderRight: 'none',
                                        },
                                        },
                                        '& .MuiDataGrid-columnSeparator': {
                                        display: 'none',
                                        },
                                    }}
                                />
                                </Box>
                            </Box>
                    </Card>
                </Grid>
            </Grid>
        </>
    );
}

export default ViewCouponDetails;